import { MuiThemeProvider } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React from 'react';
import loaderImage from '../assets/loader.gif';
import { CommentsContextProvider, CommentStateProvider, defaultLocalization, DocumentDataContext, DocumentDataProvider, DocumentPermissionsContextProvider, DocumentViewerApiSettingsProvider, LocalizationContext, PreviewImageDataContextProvider, ViewerSettingsContext, ViewerStateProvider } from "../context/index.js";
import { PreviewState } from "../enums.js";
import { defaultTheme } from "../models/index.js";
import { DocumentViewerError } from "./document-viewer-error.js";
import { DocumentViewerLayout } from "./document-viewer-layout.js";
import { DocumentViewerLoading } from "./document-viewer-loading.js";
import { DocumentViewerRegeneratePreviews } from "./document-viewer-regenerate-previews.js";
export const POLLING_INTERVAL = 5000;

/**
 * Defined the component's own properties
 */

export const DocumentViewer = props => {
  return /*#__PURE__*/React.createElement(DocumentViewerApiSettingsProvider, {
    options: props.api
  }, /*#__PURE__*/React.createElement(LocalizationContext.Provider, {
    value: deepMerge(defaultLocalization, props.localization)
  }, /*#__PURE__*/React.createElement(ViewerSettingsContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: props.theme || defaultTheme
  }, /*#__PURE__*/React.createElement(DocumentDataProvider, null, /*#__PURE__*/React.createElement(DocumentPermissionsContextProvider, null, /*#__PURE__*/React.createElement(PreviewImageDataContextProvider, null, /*#__PURE__*/React.createElement(DocumentDataContext.Consumer, null, ({
    documentData
  }) => {
    if (documentData.pageCount === PreviewState.Loading) return /*#__PURE__*/React.createElement(DocumentViewerLoading, {
      image: props.loaderImage || loaderImage
    });
    if (documentData.pageCount === PreviewState.Postponed) {
      return /*#__PURE__*/React.createElement(DocumentViewerRegeneratePreviews, null);
    } else if (documentData.pageCount < 0 || documentData.error) {
      return /*#__PURE__*/React.createElement(DocumentViewerError, null);
    }
    return /*#__PURE__*/React.createElement(ViewerStateProvider, {
      options: props.defaultState
    }, /*#__PURE__*/React.createElement(CommentStateProvider, null, /*#__PURE__*/React.createElement(CommentsContextProvider, null, /*#__PURE__*/React.createElement(DocumentViewerLayout, null))));
  }))))))));
};
//# sourceMappingURL=document-viewer.js.map